import axiosInstance from "./AxiosInstance";

export function createCashFlowApi(data){
    return axiosInstance.post('api/cash-flows',data)
}

export function deleteCashFlowApi(id){
    return axiosInstance.delete(`api/cash-flows/${id}`)
}

export function updateCashFlowApi(id,data){
    return axiosInstance.patch(`api/cash-flows/${id}`,data)
}

export function getCashFlowApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/cash-flows?${fparam}`)
}
